export default "__VITE_ASSET__4eUjLztF__"